import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export const FetchRequestBlockedError = createDatadogError('FetchRequestBlocked');
